import { formatSize, randomId, removeExt } from 'pano-utils';
import type { MatrixCheckResult } from '@types';
import { sendWarning } from '@components/Noti';
import getFileMd5 from '@utils/getFileMd5';
import getExif from '@utils/getExif';
import { MATRIX_IMAGE_LIMIT, TASK_SIZE_LIMIT } from '../../constants';

function loadImage(file: File): Promise<HTMLImageElement | void> {
  return new Promise((resolve) => {
    const image = new Image();
    image.onload = () => {
      resolve(image);
    };
    image.onerror = () => {
      resolve();
    };
    image.src = window.URL.createObjectURL(file);
  });
}

export default async function matrixImageCheck(
  file: File,
  isVip = false
): Promise<MatrixCheckResult | void> {
  const limitSize = TASK_SIZE_LIMIT.matrix;
  if (file.size > limitSize) {
    sendWarning(
      `添加失败: ${file.name} 大小超出${formatSize(
        limitSize
      )}限制，请压缩图片大小`
    );
    return;
  }
  const image = await loadImage(file);
  if (image) {
    const width = image.naturalWidth;
    const height = image.naturalHeight;

    const fn = (x: number) => x < MATRIX_IMAGE_LIMIT;
    if (fn(width) && fn(height)) {
      sendWarning(
        `添加失败: ${file.name} 尺寸不符合要求，请上传${MATRIX_IMAGE_LIMIT}像素以上的图片`
      );
      return;
    }

    window.URL.revokeObjectURL(image.src);
  } else if (!isVip) {
    sendWarning(
      `添加失败: ${file.name} - 图片加载出错, 请尝试更换或重新压制图片`
    );
    return;
  }

  const md5 = await getFileMd5(file);
  const { exif, gps } = await getExif(file);

  return {
    id: randomId(`${md5}_`),
    file,
    name: removeExt(file.name),
    size: file.size,
    md5,
    gps,
    exif,
  };
}
